<div class="bmc-connect-triggers">
  <h5>{{'TRIGGERS.DESCRIPTION' | translate}}</h5>

  <div class="bmc-triggers">
    <div class="bmc-triggers__list">
      <h4 class="bmc-triggers__list__title">{{'TRIGGERS.TITLE_LIST' | translate}}</h4>
      <ul class="bmc-triggers-list">
        <li *ngFor="let triggerConnectionModel of triggersConnectionModelType">
          <div class="bmc-triggers-list__item" (click)="triggerConnectionModel.isExpanded = !triggerConnectionModel.isExpanded">
            <div class="bmc-triggers-list__item__text bz-flex">
              <bzg-icon [nameIcon]="'icon-bizagi'" [size]="16"></bzg-icon>
              <span class="bmc-triggers-name">{{triggerConnectionModel.displayName}}</span>
            </div>
            <div>
              <span class="bmc-triggers-version"></span>
              <bzg-icon [nameIcon]="triggerConnectionModel.isExpanded ? 'arrow-up' : 'arrow-down'" [size]="14"></bzg-icon>
            </div>
          </div>
          <ul *ngIf="triggerConnectionModel.isExpanded && triggerConnectionModel.triggersConnections.length" [@bzgSlideDown]>
            <li class="bmc-triggers-sublist" *ngFor="let triggerConn of triggerConnectionModel.triggersConnections"
              (click)="selectTriggerConnection(triggerConn)"
              [ngClass]="{'bz-color-bg--theme-100': selectedTriggerConnection && (selectedTriggerConnection.id === triggerConn.id )}">
              <span class="">{{triggerConn.displayName}}</span>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="bmc-triggers-config">
      <div class="bz-env-loading">
        <bounce *ngIf="isBusy"></bounce>
      </div>
      <div class="bmc-triggers-config__container " *ngIf="selectedTriggerConnection && !isBusy">
        <biz-connect-triggers-detail #triggerDetail           
          [selectedTriggerConn]="selectedTriggerConnection"
          [redirecUrl] = "redirecUrl">
        </biz-connect-triggers-detail>
      </div>
      <div class="bmc-triggers-config__buttons" *ngIf="selectedTriggerConnection">
        <bzg-button-secondary class="bz-space--inline-m" (click)="cancelChanges()">
          {{ 'GLOBAL.CANCEL' | translate }}
        </bzg-button-secondary>
        <bzg-button-primary [disabled]="!authenticated()" (click)="saveTriggerConnection()">
          {{ 'GLOBAL.APPLY' | translate }}
        </bzg-button-primary>
      </div>
    </div>
  </div>
</div>